'use client';

import classNames from 'classnames';
import type { ComponentPropsWithRef, FC, ReactEventHandler } from 'react';

import styles from './radio.module.scss';

const defaultOnInvalid: ReactEventHandler<HTMLInputElement> = (e) => {
  e.preventDefault();
};

export type RadioProps = Omit<ComponentPropsWithRef<'input'>, 'type'>;

export const Radio: FC<RadioProps> = ({ className, checked, onInvalid, ...props }) => (
  <span className={classNames(styles.wrapper, className)}>
    <input
      type="radio"
      checked={checked}
      onInvalid={onInvalid ?? defaultOnInvalid}
      {...props}
      className={classNames(styles.radio)}
    />
    <span className={classNames(styles.circle, checked && styles.checked)}></span>
  </span>
);
